import { connect, ConnectedProps } from 'react-redux';
import { Navigate } from 'react-router-dom-v5-compat';

import { NavItem } from 'dashboard/models/role';
import { RootState } from 'dashboard/redux/store';

const DASHBOARD_PAGE_TO_PERMISSION: Record<string, NavItem> = {
  inquiries: NavItem.Inquiry,
  cases: NavItem.Case,
};

const DashboardRoute = (props: PropsFromRedux) => {
  // Redirect to /user if default_landing_page is null, indicating that the user is not fully authenticated
  if (!props.currentUser.attributes['default-landing-page']) {
    return <Navigate to='/dashboard/user' state={{ from: location?.pathname }} replace />;
  }

  // Otherwise, ensure that the user's enabled-nav-items includes the default_landing_page, if it is not '/home' (fallback to '/user' if not)
  const defaultLandingPageName = props.currentUser.attributes['default-landing-page'].replace(
    '/',
    '',
  );

  const firstAccessiblePage =
    defaultLandingPageName === 'home'
      ? 'home'
      : props.currentUser.attributes['enabled-nav-items']?.includes(
            DASHBOARD_PAGE_TO_PERMISSION[defaultLandingPageName],
          )
        ? defaultLandingPageName
        : 'user';

  return (
    <Navigate
      to={`/dashboard/${firstAccessiblePage}`}
      state={{ from: location?.pathname }}
      replace
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: state.currentUser.currentUser,
  };
};

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardRoute);
